// extracted by mini-css-extract-plugin
export default {"mRight":"styles_mRight__3I4Q5","checkbox":"styles_checkbox__NIGVv","checkboxSquireWrapper":"styles_checkboxSquireWrapper__k0nR5","checkboxSquire":"styles_checkboxSquire__wts+m"};